import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">IoT</div>
      <div className="navbar-links">
        <NavLink to="/" end className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
          Dashboard
        </NavLink>
        <NavLink to="/sensors" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
          Sensores
        </NavLink>
      </div>
      <div className="navbar-user">
        <span className="navbar-username">{user.username}</span>
        <button onClick={handleLogout} className="btn-logout">Sair</button>
      </div>
    </nav>
  );
}

export default Navbar;
